module.exports = __webpack_public_path__ + "static/img/Jack-Wighton.36b508d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Wighton.jpg
// module id = jnE5
// module chunks = 0